/**
 * PriceChange — the canonical signed-delta primitive (Descout design system).
 *
 * Mono, semibold. up = value>=0 (signal-green), down = alert-red, null = parchment-dim "—".
 * Renders: optional arrow (▲/▼) + sign (+ / − U+2212) + |value| + %.
 *   e.g. "▲ +9.2%", "▼ −2.5%", "—".
 *
 * Pure/presentational — no client hooks, safe in server components.
 */
import React from 'react';

export default function PriceChange({
  value,
  showArrow = true,
  className = '',
}: {
  value: number | null;
  showArrow?: boolean;
  className?: string;
}) {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return (
      <span className={`font-mono font-semibold text-parchment-dim ${className}`}>—</span>
    );
  }

  const up = value >= 0;
  const arrow = up ? '▲' : '▼'; // ▲ / ▼
  const sign = up ? '+' : '−'; // + / − (U+2212)
  const tone = up ? 'text-signal-green-text' : 'text-alert-red-text';

  return (
    <span className={`font-mono font-semibold ${tone} ${className}`}>
      {showArrow && <span aria-hidden>{arrow} </span>}
      {sign}
      {Math.abs(value).toFixed(1)}%
    </span>
  );
}
